import moment from 'moment/moment'
import React from 'react'

const DateView = ({ date, format = 'DD/MM/YYYY', showTime = false, timezone = null }) => {
	return (
		<>{moment(date).format(format)}</>
	)
}

export default DateView